var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailPurp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 5.625H3.75C3.50136 5.625 3.2629 5.72377 3.08709 5.89959C2.91127 6.0754 2.8125 6.31386 2.8125 6.5625V22.5C2.8125 22.9973 3.01004 23.4742 3.36167 23.8258C3.71331 24.1775 4.19022 24.375 4.6875 24.375H25.3125C25.8098 24.375 26.2867 24.1775 26.6383 23.8258C26.99 23.4742 27.1875 22.9973 27.1875 22.5V6.5625C27.1875 6.31386 27.0887 6.0754 26.9129 5.89959C26.7371 5.72377 26.4986 5.625 26.25 5.625ZM23.8395 7.5L15 15.6035L6.16055 7.5H23.8395ZM25.3125 22.5H4.6875V8.69414L14.366 17.5664C14.539 17.7252 14.7652 17.8133 15 17.8133C15.2348 17.8133 15.461 17.7252 15.634 17.5664L25.3125 8.69414V22.5Z",
    fill: "#7F43FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPurp);
export default __webpack_public_path__ + "static/media/email-purp.b1be587bb813499c0444b13b0faaed5b.svg";
export { ForwardRef as ReactComponent };